module.exports = {
  // 标题
  title: '英语习得教育',

  // 视频域名
  videoDomain: 'https://qd-hlyy.oss-cn-qingdao.aliyuncs.com/'
}

